/* eslint-disable no-tabs */
const IconEditSvg = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33333 12.6667H4.276L10.4853 6.45739L9.54267 5.51472L3.33333 11.7241V12.6667ZM14 14.0001H2V11.1714L10.9567 2.21472C11.0817 2.08974 11.2512 2.01953 11.428 2.01953C11.6048 2.01953 11.7743 2.08974 11.8993 2.21472L13.7853 4.10072C13.9103 4.22574 13.9805 4.39528 13.9805 4.57206C13.9805 4.74883 13.9103 4.91837 13.7853 5.04339L6.162 12.6667H14V14.0001ZM10.4853 4.57206L11.428 5.51472L12.3707 4.57206L11.428 3.62939L10.4853 4.57206Z"
        fill="#017849"
      />
    </svg>
  )
}

export default IconEditSvg
